import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Graph = () => {
    return (
        <Container>
            <Link to="/">Home</Link>
            <h1>Graph</h1>
        </Container>
    )
}

export default Graph